const getAuthUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_AUTH_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
};

const getApiUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_API_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
};

const getRentUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_RENT_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_RENT_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_RENT_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_RENT_URI;
};

const getAppUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_APP_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
};

const DEFAULT_AUTH_URL = getAuthUrl() + "v1/";
const DEFAULT_API_URL = getApiUrl() + "v1/";
const DEFAULT_RENT_URL = getRentUrl() + "v1/";
const DEFAULT_APP_URL = getAppUrl() + "v1/";

export const LOGIN_URL = DEFAULT_AUTH_URL + "login";
export const SIGNUP_URL = DEFAULT_AUTH_URL + "signup";

export const FIND_EMAIL_URL = DEFAULT_AUTH_URL + "find_email";
export const MEMBER_WITHDRAW_URL = DEFAULT_AUTH_URL + "member/withdraw";
export const RESET_PASSWORD_URL = DEFAULT_AUTH_URL + "reset_password";

export const USER_URL = DEFAULT_AUTH_URL + "user/";

export const RENT_CAR_ADD_URL = DEFAULT_RENT_URL + "rent/car";
export const RENT_CAR_URL = RENT_CAR_ADD_URL + "/";
export const RENT_CARS_URL = DEFAULT_RENT_URL + "rent/cars";
export const RENT_CARS_ALL_URL = DEFAULT_RENT_URL + "rent/cars/all";

export const RENT_ADD_URL = DEFAULT_RENT_URL + "rent";
export const RENT_URL = RENT_ADD_URL + "/";
export const RENTS_URL = DEFAULT_RENT_URL + "rents";
export const RENT_ADD_ADMIN_URL = DEFAULT_RENT_URL + "rent/admin";

export const RENT_CANCEL_URL = "/cancel";
export const RENT_USE_URL = "/start";
export const RENT_CANCEL_USE_URL = "/start/cancel";
export const RENT_RETURN_URL = "/end";
export const RENT_ARRIVE_URL = "/arrive";
export const RENT_MINE_URL = RENTS_URL + "/mine";
export const RENT_START_LIST_URL = RENTS_URL + "/start";
export const RENT_END_LIST_URL = RENTS_URL + "/end";
export const RENT_ALL_URL = RENTS_URL + "/all";

export const RENT_IMAGE_ADD_START_URL = "/start/images";
export const RENT_IMAGE_ADD_END_URL = "/end/images";
export const RENT_IMAGE_URL = RENT_URL + "image/";

export const RENT_PAYMENT_ADD_URL = RENT_URL + "payment";
export const RENT_PAYMENT_URL = RENT_PAYMENT_ADD_URL + "/";
export const RENT_PAYMENT_CANCEL_URL = RENT_PAYMENT_URL + "cancel/";
export const RENT_PAYMENT_COMPLETE_URL = RENT_PAYMENT_URL + "complete";
export const RENT_PAYMENT_PREPARE_URL = RENT_PAYMENT_URL + "prepare/";
export const RENT_PAYMENT_CATEGORIES_URL = RENT_PAYMENT_URL + "categories";
export const RENT_PAYMENT_CATEGORY_URL = RENT_PAYMENT_URL + "category";
export const RENT_PAYMENT_ITEMS_URL = RENT_PAYMENT_URL + "items";

export const RENT_PAID_ITEMS_URL = RENT_URL + "paid-items";

export const DRIVER_LICENSE_ADD_URL = USER_URL + "driver-license";
export const DRIVER_LICENSE_URL = DRIVER_LICENSE_ADD_URL + "/";
export const IMAGE_URL = "/image";

export const DOOR_CAR_URL = DEFAULT_APP_URL + "car/";
export const DOOR_CAR_CLOSE_URL = "/door/close";
export const DOOR_CAR_OPEN_URL = "/door/open";
export const SWING_DOOR_CAR_CLOSE_URL = "/door/swing/close";
export const SWING_DOOR_CAR_OPEN_URL = "/door/swing/open";
export const DOOR_STATUS_URL = DEFAULT_APP_URL + "cars/door/status";

export const CAR_OWNERS = DEFAULT_APP_URL + "car/owner";
export const OWNERS_MINE_URL = DEFAULT_APP_URL + "car/owners/mine";
export const CAR_SHARER_URL = DEFAULT_APP_URL + "car/sharer";
export const CAR_SHARER_INFO_URL = CAR_SHARER_URL + "/";
export const SHARER_MINE_URL = DEFAULT_APP_URL + "car/sharers/mine";
export const CAR_SHARERS_URL = DEFAULT_APP_URL + "car/sharers";

export const FIND_EV_STATION_URL = DEFAULT_APP_URL + "openapi/evcs";

export const RENT_HOLIDAYS_URL = DEFAULT_RENT_URL + "holidays";

export const RENT_CARS_LOCATION_URL = DEFAULT_RENT_URL + "rent/cars/location";
